import { useQuery } from '@tanstack/react-query';
import { Card } from 'antd';
import dayjs from 'dayjs';
import { CSSGrid } from '@/common/components';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';
import AnalysisMetricCard from '@/apps/trace/components/AnalysisMetricCard';
import { queryTraceAnalysis } from '@/apps/trace/services/analysis';

const dateFormat = 'YYYY-MM-DD';

const getLocalDayjs = (date) =>
  dayjs(new Date(date.getFullYear(), date.getMonth(), date.getDate()));

const getCurrentWeekRange = () => {
  const today = dayjs();
  const todayDate = today.toDate();
  const weekday = todayDate.getDay() || 7;
  const startDate = new Date(todayDate);
  startDate.setDate(todayDate.getDate() + 1 - weekday);
  return {
    end: today.format(dateFormat),
    start: getLocalDayjs(startDate).format(dateFormat),
  };
};

export default function WorkplaceTraceSummary() {
  const { organizationId } = useOrganizationPath();
  const currentWeekRange = getCurrentWeekRange();
  const { data = {}, isLoading } = useQuery({
    enabled: Boolean(organizationId),
    queryFn: () =>
      queryTraceAnalysis({
        accountType: 'own',
        end: currentWeekRange.end,
        organizationId,
        period: 'week',
        start: currentWeekRange.start,
      }),
    queryKey: [
      'workplace',
      'trace-summary',
      organizationId,
      currentWeekRange.start,
      currentWeekRange.end,
    ],
  });

  return (
    <Card loading={isLoading} title="总量统计" variant="borderless">
      <CSSGrid columns={{ xs: 1, sm: 2, xl: 4 }} gap="large">
        {(data.summary || []).map((item) => (
          <AnalysisMetricCard key={item.key} item={item} />
        ))}
      </CSSGrid>
    </Card>
  );
}
